import {emitYmEvent} from '@web-landing/analytics/helpers/ymEvent';

export const ym_log = {
  headerSearchButtonClick: () => {
    emitYmEvent('header_menu_button_search');
  },
  searchBarClick: () => {
    emitYmEvent('searchBar_click');
  },
  searchBarSearchButtonClick: () => {
    emitYmEvent('header_menu_search');
  },
};
